import * as yup from "yup";

const passwordRegExp = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).*$/;

const LoginVS = yup.object().shape({
  email: yup
    .string()
    .required("Email is required")
    .email("Invalid Email")
    .label("email"),
  password: yup.string().required("Password is required").label("password"),
});

const ForgotPasswordVS = yup.object().shape({
  email: yup
    .string()
    .required("Email is required")
    .email("Invalid Email")
    .label("email"),
});

const ResetPasswordVS = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .matches(
      passwordRegExp,
      "Password must contain a minimum of 8 characters, including at least one upper case character, one lower case character, one special character and one number"
    ),
  confirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password"), ""], "Passwords must match"),
});

const UpdatePasswordVS = yup.object().shape({
  oldPassword: yup.string().required("Current password is required"),
  password: yup
    .string()
    .required("New password is required")
    .matches(
      passwordRegExp,
      "Password must contain a minimum of 8 characters, including at least one upper case character, one lower case character, one special character and one number"
    ),
  confirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password"), ""], "Passwords must match"),
});

const UpdateProfileVS = yup.object().shape({
  fullname: yup.string().required("Full name  is required").label("Full Name"),
  role: yup.string().required("Role is required").label("Role"),
});

const QuestionnaireStep1VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup
        .string()
        .required("Job Title is required")
        .trim("Job Title cannot include leading and trailing spaces")
        .strict(true)
        .label("Job Title")
        .min(3, "Job Title must be at least 3 characters long"),
      department: yup
        .string()
        .required("Department is required")
        .trim("Department cannot include leading and trailing spaces")
        .strict(true)
        .label("Department"),
      jobCode: yup
        .string()
        .label("Job Code")
        .trim("Department cannot include leading and trailing spaces")
        .strict(true),
      jobGrade: yup
        .string()
        .optional()
        .label("Job Grade")
        .trim("Department cannot include leading and trailing spaces")
        .strict(true),
      roleType: yup
        .object()
        .required("Role Type is required")
        .label("Role Type"),
    })
  ),
});

const QuestionnaireStep2VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      levelWork: yup
        .object()
        .required("Level of Work is required")
        .label("Level of Work"),
      modifier: yup.object().required("Modifier is required").label("Modifier"),
      definition: yup.string().optional().label("definition"),
      output: yup.string().optional().label("RAS Output"),
      alldropDowns: yup.array().optional().label("All Drop Downs"),
    })
  ),
});

const QuestionnaireStep3VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      institutionalExpertise: yup
        .object()
        .required("Institutional Expertise & Scope is required")
        .label("Institutional Expertise & Scope"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep4VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      culturalImpact: yup
        .object()
        .required("Cultural Impact & Communication is required")
        .label("Cultural Impact & Communication"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep5VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      physicalEnvironment: yup
        .object()
        .required("Physical Environment is required")
        .label("Physical Environment"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep6VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      mentalEnvironment: yup
        .object()
        .required("Mental & Emotional Environment  is required")
        .label("Mental & Emotional Environment "),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep7VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      applicationLevel: yup
        .object()
        .required("Application of Knowledge & Skill is required")
        .label("Application of Knowledge & Skill"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep8VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      manualEffort: yup
        .object()
        .required("Manual Effort is required")
        .label("Manual Effort"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep9VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      outcomes: yup
        .object()
        .required("Outcomes  is required")
        .label("Outcomes"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep10VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      notes: yup.string().optional().label("Notes"),
    })
  ),
});

const ContactVS = yup.object().shape({
  subject: yup.string().required("Subject is required").label("Subject"),
  message: yup
    .string()
    .required("Message is required")
    .label("Message")
    .max(3000, "Message can't be more than 3000 characters long"),
});

export {
  LoginVS,
  ForgotPasswordVS,
  ResetPasswordVS,
  UpdatePasswordVS,
  UpdateProfileVS,
  QuestionnaireStep1VS,
  QuestionnaireStep2VS,
  QuestionnaireStep3VS,
  QuestionnaireStep4VS,
  QuestionnaireStep5VS,
  QuestionnaireStep6VS,
  QuestionnaireStep7VS,
  QuestionnaireStep8VS,
  QuestionnaireStep9VS,
  QuestionnaireStep10VS,
  ContactVS,
};
